import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiDisneyFilterConfig } from '@/data/landingConfig/landingAiDisneyFilterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiDisneyFilter } from './schemaObject';

interface Props {}
const AiDisneyFilter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiDisneyFilter} />
			<LandingTemplate
				data={landingAiDisneyFilterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiDisneyFilter;
